import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/webforyou.svg';
import CTASection from '../components/CTASection';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gray-900 text-white py-4">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/">
            <img src={logo} alt="WebForYou Support" className="h-8 w-auto" />
          </Link>

          {/* Hamburger menü mobil nézeten */}
          <button
            className="md:hidden p-2 z-50 relative"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menü"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <span 
                className={`block absolute h-0.5 w-8 bg-current transform transition duration-500 ease-in-out ${
                  isMenuOpen ? 'rotate-45' : '-translate-y-2'
                }`}
              />
              <span 
                className={`block absolute h-0.5 w-8 bg-current transition-opacity duration-500 ease-in-out ${
                  isMenuOpen ? 'opacity-0' : 'opacity-100'
                }`}
              />
              <span 
                className={`block absolute h-0.5 w-8 bg-current transform transition duration-500 ease-in-out ${
                  isMenuOpen ? '-rotate-45' : 'translate-y-2'
                }`}
              />
            </div>
          </button>

          {/* Asztali menü */}
          <nav className="hidden md:block">
            <ul className="flex items-center space-x-8">
              <li>
                <Link 
                  to="/" 
                  className="text-gray-300 hover:text-purple-400 transition-all duration-300 text-sm font-medium relative group"
                >
                  <span className="relative inline-block">
                    Kezdőoldal
                    <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
                  </span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/kapcsolat" 
                  className="text-gray-300 hover:text-purple-400 transition-all duration-300 text-sm font-medium relative group"
                >
                  <span className="relative inline-block">
                    Kapcsolat
                    <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
                  </span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/adatvedelem" 
                  className="text-gray-300 hover:text-purple-400 transition-all duration-300 text-sm font-medium relative group"
                >
                  <span className="relative inline-block">
                    Adatvédelem
                    <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
                  </span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Mobil menü */}
        <div 
          className={`fixed inset-0 bg-gradient-to-b from-gray-900 to-purple-900/95 backdrop-blur-sm z-40 transform transition-transform duration-500 ease-in-out ${
            isMenuOpen ? 'translate-x-0' : 'translate-x-full'
          } md:hidden`}
        >
          <nav className="h-full flex flex-col items-center justify-center px-6">
            <ul className="flex flex-col space-y-16 text-center w-full mb-16">
              <li>
                <Link 
                  to="/" 
                  className="text-5xl text-white hover:text-purple-400 transition-all duration-300 font-bold block py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <span className="relative group inline-block">
                    Kezdőoldal
                    <span className="absolute -bottom-4 left-0 w-0 h-1 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
                  </span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/kapcsolat" 
                  className="text-5xl text-white hover:text-purple-400 transition-all duration-300 font-bold block py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <span className="relative group inline-block">
                    Kapcsolat
                    <span className="absolute -bottom-4 left-0 w-0 h-1 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
                  </span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/adatvedelem" 
                  className="text-5xl text-white hover:text-purple-400 transition-all duration-300 font-bold block py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <span className="relative group inline-block">
                    Adatvédelem
                    <span className="absolute -bottom-4 left-0 w-0 h-1 bg-purple-400 transition-all duration-300 group-hover:w-full"></span>
                  </span>
                </Link>
              </li>
            </ul>
            <CTASection />
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header; 